import { getCanonicalSearchUrl } from '@eventbrite/search-utils';
import { OrganicEventSearchFiltersApiPayload } from '../api/searchOrganicEvents';

/**
 * Returns a properly formatted search url.
 *
 * @param currentQuery OrganicEventSearchFiltersApiPayload from SearchContext
 * @param location_slug The location slug to use in the url
 * @param addPageQueryParam Whether or not to include page=1 query param in the url
 * @param usesLanguageSubdirectory Whether or not to include the language subdirectory in the url
 * @param locale The locale to use in the url
 */
export const generateSearchUrl = ({
    currentQuery,
    locationSlug = '',
    addPageQueryParam = true,
    usesLanguageSubdirectory = false,
    locale = '',
}: {
    currentQuery: OrganicEventSearchFiltersApiPayload;
    locationSlug?: string;
    addPageQueryParam?: boolean;
    usesLanguageSubdirectory?: boolean;
    locale?: string;
}): string => {
    const currentQueryPath = getCanonicalSearchUrl({
        slug: currentQuery?.online_events_only ? 'online' : locationSlug,
        price: currentQuery.price,
        tags: currentQuery.tags,
        dates: currentQuery.dates,
        q: currentQuery.q,
        bbox: currentQuery.bbox,
        usesLanguageSubdirectory,
        locale,
    });

    const queryParams: string[] = [];

    if (addPageQueryParam) {
        queryParams.push('page=1');
    }

    if (currentQuery.date_range) {
        queryParams.push(
            `start_date=${currentQuery.date_range.from}&end_date=${currentQuery.date_range.to}`,
        );
    }

    if (queryParams.length) {
        const queryParamsStr = queryParams.join('&');
        const queryPathWithParams = currentQueryPath.includes('?')
            ? `${currentQueryPath}&${queryParamsStr}`
            : `${currentQueryPath}?${queryParamsStr}`;

        return queryPathWithParams;
    }

    return currentQueryPath;
};
